/* eslint-disable react/jsx-props-no-spreading */
import React, { createContext } from 'react';

export const { Provider, Consumer } = createContext();

export const withContext = (Component) => (props) => (
  <Consumer>{(values) => <Component {...values} {...props} />}</Consumer>
);
